/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Warnings_Status {
    NO_AVAILABILITY = 'noAvailability',
    TEMPORARILY_UNAVAILABLE = 'temporarilyUnavailable',
    INSUFFICIENT_AVAILABILITY = 'insufficientAvailability',
}
